import { Component, Input } from '@angular/core';
import { CashcutListItemModel } from '../../../../shared/models/cashcutListItem.model';
import { Select } from '@ngxs/store';
import { AppState } from '../../../../state/appState';
import { Observable } from 'rxjs';
import { LanguageModel } from '../../../../shared/models/language.model';

@Component({
  selector: 'app-cashcut-list-item',
  templateUrl: './cashcut-list-item.component.html',
  styleUrls: ['./cashcut-list-item.component.scss'],
})
export class CashcutListItemComponent {
  @Select(AppState.currentLanguage$)
  currentLanguage$: Observable<LanguageModel>;

  @Input() cashcutListItem: CashcutListItemModel;

  constructor() {}
}
